import React, { useState, useEffect } from "react";
import * as HiIcons from "react-icons/hi";
import * as AiIcons from "react-icons/ai";
import { Link } from "react-router-dom";
import "../Navbar/navbar.css";

function EventNav() {
  const [nav, setNav] = useState(false);
  const [scrolled, setScrolled] = useState(false); // új állapot a scroll figyeléshez

  const handleNav = () => setNav(!nav);
  const closeMenu = () => setNav(false);

  // Scroll figyelése
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      id="home"
      className={`header ${scrolled ? "scrolled" : ""}`} // scroll alapján class
    >
      <div className="navbar-container">
        {/* Bal oldal: cégnév */}
        <div className="helpo-navbar-left">
  <Link to="/" onClick={closeMenu}>
    <img src="logo.png" alt="logo" className="helpo-logo" />
  </Link>
</div>

        {/* Asztali menü */}
        <ul className="header-menu">
          <li className="header-li"><Link to="/" onClick={closeMenu}>Main</Link></li>
          <span className="separator">|</span>
          <li className="header-li"><Link to="/help" onClick={closeMenu}>How can we help?</Link></li>
          <span className="separator">|</span>
          <li className="header-li"><Link to="/about" onClick={closeMenu}>Our Expertise</Link></li>
          <span className="separator">|</span>
          <li className="header-li"><Link to="/question" onClick={closeMenu}>FAQ's</Link></li>
          <span className="separator">|</span>
          <li className="header-li"><Link to="/aboutus" onClick={closeMenu}>About Us</Link></li>
        </ul>

        {/* Hamburger */}
        <div className="hamburger" onClick={handleNav}>
          {!nav ? <HiIcons.HiOutlineMenuAlt4 className='icon' /> : <AiIcons.AiOutlineClose className='icon' />}
        </div>

       {/* Mobil menü */}
       <div className={nav ? "mobile-menu active" : "mobile-menu"}>
          <div className="mobile-menu-header">
            <img src="logo.png" alt="Logo" className="mobile-logo" />
          </div>
          <ul>
            <li><Link to="/" onClick={closeMenu}>Main</Link></li>
            <li><Link to="/about" onClick={closeMenu}>Our Expertise</Link></li>
            <li><Link to="/help" onClick={closeMenu}>How can we help?</Link></li>
            <li><Link to="/aboutus" onClick={closeMenu}>About Us</Link></li>
            <li><Link to="/question" onClick={closeMenu}>FAQ's</Link></li>
            <li><Link to="/event" onClick={closeMenu}>Events</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default EventNav;